import * as React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import { IJobReportComponentPropsData, IJobReportComponentPropsFunctions } from "../props/IJobReportComponentProps";
import IJobCalculation from "../interfaces/IJobCalculation";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglassStart, faSpinner, faCheck, faTimes, faExclamation, faStop } from '@fortawesome/free-solid-svg-icons'
import { calculationStatusIcons, calculationStatusNames } from "../../../settings";
library.add(faHourglassStart, faSpinner, faCheck, faTimes, faExclamation, faStop);

type IProps = IJobReportComponentPropsData & IJobReportComponentPropsFunctions;

class Calculation extends React.Component<IJobCalculation, {modal: boolean}> {
    
    state = {
        modal: false,
    }
    
    toggle = () => {
        this.setState({modal: !this.state.modal});
    }
    
    handleClick = evt => {
        evt.preventDefault();
        this.toggle();
    }

    handleRename = (module) => {
        if(module === "pdbPreparation") return "Structure preparation";
        if(module === "btc") return "Back-to-consensus analysis";
        if(module === "conservationAnalysis") return "Conservation analysis";
        if(module === "existenceInAlignment") return "Mutation occurence";
        if(module === "msa") return "Multiple sequence alignment";
        if(module === "cmanalysis") return "Correlation analysis";
        if(module === "bfitter") return "B-factor analysis";
        if(module === "stability") return "Energy calculation";
        if(module === "multimutants") return "Multiple-point designs";
        if(module === "homologyModeling") return "Homology modelling";
        if(module === "asr") return "Ancestral reconstruction";
    }
    
    render() {
        
        const icon = this.props.returnCode == 2 ? ["exclamation", "#ff9900"] : calculationStatusIcons[this.props.status];
        return <tr>
            <td style={{color: icon[1]}}>
                <FontAwesomeIcon icon={icon[0]} pulse={icon[0] === "spinner"} />
            </td>
            <td>
                <a href="#" onClick={this.handleClick}>
                    {this.handleRename(this.props.moduleName)}
                </a>
                <Modal
                    isOpen={this.state.modal}
                    centered={true}
                    toggle={this.toggle}
                    fade={false}
                    className="ll-job-report-modal"
                >
                    <ModalHeader toggle={this.toggle}>
                        Log report for calculation: {this.handleRename(this.props.moduleName)}
                    </ModalHeader>
                    <ModalBody>
                        <Table
                            className="ll-job-report-modal-table-1"
                            size="sm"
                            bordered
                        >
                            <tbody>
                                <tr>
                                    <th>Status:</th>
                                    <td>{calculationStatusNames[this.props.status]}</td>
                                </tr>
                                <tr>
                                    <th>Start time:</th>
                                    <td>{this.props.startTime}</td>
                                </tr>
                                <tr>
                                    <th>End time:</th>
                                    <td>{this.props.endTime}</td>
                                </tr>
                                <tr>
                                    <th>Description:</th>
                                    <td>{/* TODO */}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table
                            className="ll-job-report-modal-table-2"
                            size="sm"
                            hover
                            bordered
                        >
                            <thead>
                                <tr>
                                    <th>Time</th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.jobLogs.map(({ time, message, logId }) => (
                                    <tr key={logId}>
                                        <td>{time}</td>
                                        <td>{message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
            </td>
        </tr>
    }
    
}

class JobReportComponent extends React.Component<IProps> {
    
    render() {
        return <table className="ll-job-report-container">
            <tbody>
                {this.props.calculations.map(calc => <Calculation key={calc.calculationId} {...calc} />)}
            </tbody>
        </table>
    }
    
}

export default JobReportComponent;
